export enum UserConstants {
  SET_AUTHORIZATION = 'user/SET_AUTHORIZATION',
  RESET_USER = 'user/RESET_USER',
  SET_USER_ID = 'user/SET_USER_ID',
  SET_USER_NAME = 'user/SET_USER_NAME',
  SET_SERVICE = 'user/SET_SERVICE',
  SET_PASSWORD = 'user/SET_PASSWORD',
  SET_EMAIL = 'user/SET_EMAIL',
  SET_DATABASE_USER_NAME = 'user/SET_DATABASE_USER_NAME',
  SET_USER_TYPE_DATA = 'user/SET_USER_TYPE_DATA',
  SET_USER_NAME_VERIFIED = 'user/SET_USER_NAME_VERIFIED',
  SET_NOW_LOGIN_ATTEMPTED_POST_OKTA = 'user/SET_NOW_LOGIN_ATTEMPTED_POST_OKTA',
  SET_TEMP_OKTA_ACCESS_TOKEN = 'user/SET_TEMP_OKTA_ACCESS_TOKEN',
  SET_PRIVILEGES = 'user/SET_PRIVILEGES',
}
